import { render } from "./Perfil-Component.vue?vue&type=template&id=41eadaca"
import script from "./Perfil-Component.vue?vue&type=script&lang=js"
export * from "./Perfil-Component.vue?vue&type=script&lang=js"

import "./Perfil-Component.vue?vue&type=style&index=0&id=41eadaca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__